export { default, CloudPath } from './CloudinaryImage'
